<div class="row-btn-species" matRipple>
    <div class="species-icon" [hidden]="iconName == undefined">
        <img [src]="'assets/icons/'+iconName+'.svg'" alt="">
    </div>
    <div class="species-info" [innerHTML]="tableLayout"></div>
    <div class="indicator-icon">
        <button mat-icon-button>
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
    </div>
</div>
